import React, { memo } from 'react'
import type { SendReminderResponse } from 'src/interfaces/reminder'
import { ResendWithCooldown } from './ResendWithCooldown'

interface Props {
  contractorName: string
  resendAvailableAt: string | null
  onResend(): Promise<SendReminderResponse | null>
}

const ResendRecollectionComponent = ({ contractorName, resendAvailableAt, onResend }: Props) => {
  return (
    <ResendWithCooldown
      contractorName={contractorName}
      resendAvailableAt={resendAvailableAt}
      onResend={onResend}
      buttonLabel="Resend Recollection"
      confirmTitle="Resend Recollection?"
      confirmTextPrefix="Resend recollection to"
      helperLabel="Resend recollection"
      limitReachedText="You can resend the recollection once the cooldown period ends."
    />
  )
}

export const ResendRecollection = memo(ResendRecollectionComponent)
